export default {
  init() {
    function setup() {
      // ✅ Caricamento curriculum
      const fileInput = document.getElementById('cv-upload');
      const label = document.querySelector('label.custom-file-upload');

      if (fileInput && label) {
        let message = document.createElement('div');
        message.textContent = '✅ Curriculum caricato!';
        message.style.color = 'green';
        message.style.marginTop = '0.5rem';
        message.style.display = 'none';
        label.insertAdjacentElement('afterend', message);

        fileInput.addEventListener('change', () => {
          message.style.display = fileInput.files.length > 0 ? 'block' : 'none';
        });
      }

      // ✅ Cambio valore della select
      const buttons = document.querySelectorAll('.btn-candidati');

      buttons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          const posizione = button.getAttribute('data-posizione');
          const select = document.getElementById('campo-posizione');

          if (select && posizione) {
            const option = Array.from(select.options).find(o => o.value === posizione);
            if (option) {
              select.value = posizione;
            }
          }

          document.getElementById('responsive-form')?.scrollIntoView({ behavior: 'smooth' });
        });
      });
    }

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', setup)
      : setup();
  },
  finalize() {}
};
